import { ArrowRight, Modal, UNEPLogoSmall } from "@wesr/wesr-design-system";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import {
  ModalButton,
  ModalContantContainer,
  ModalDescription,
  ModalTextContainer,
  ModalTitle,
} from "./WelcomeModal.styles";
import { WelcomeModalProps } from "./WelcomeModal.types";

const WelcomeModal: FC<WelcomeModalProps> = ({ isOpen = false, handleClose, handleAccept }) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <ModalContantContainer>
        <UNEPLogoSmall />
        <ModalTextContainer>
          <ModalTitle>{t("pocWelcomeModal.title")}</ModalTitle>
          <ModalDescription>{t("pocWelcomeModal.description")}</ModalDescription>
        </ModalTextContainer>
        <ModalButton variant="contained" onClick={handleAccept} endIcon={<ArrowRight />}>
          {t("pocWelcomeModal.buttonLabel")}
        </ModalButton>
      </ModalContantContainer>
    </Modal>
  );
};

export default WelcomeModal;
